import Logos from '@/components/LogoCarousel'

interface ClientLogosSectionProps {
  dictionary: Dictionary['home']['partners'] // More specific type
}

export const ClientLogosSection: React.FC<ClientLogosSectionProps> = ({ dictionary }) => {
  return (
    <div className='bg-slate-900 py-8'>
      <div className='container mx-auto px-4'>
        <div className='mb-6 text-center'>
          <span className='text-sm font-medium tracking-wider text-blue-400'>{dictionary.subtitle}</span>
          <h2 className='text-xl font-bold text-white'>{dictionary.title}</h2>
        </div>
        <Logos />
      </div>
    </div>
  )
}
